import { SelectTable } from "_components/Abstractions/SelectTable";
import { useEffect, useState } from "react";
import { KeoBdoTable } from "./KeoBdoTable";
import { KeoBdoSearcher } from "./KeoBdoSearcher";
import { useFormContext } from "react-hook-form";
import { useKeoCardsSearch } from "./useKeoCardsSearch";

export function KeoBdoSelectTable({ name }) {
  const { setValue } = useFormContext();
  const [show, setShow] = useState(false);
  const { items, onSearchChange } = useKeoCardsSearch();

  const onSelect = (item) => {
    setValue(name, item, { shouldValidate: true, shouldTouch: true, shouldDirty: true });
    setShow(false);
  };

  useEffect(() => {
    onSearchChange(null);
  }, []);

  const searcherData = { onSearchChange };
  const table = (<KeoBdoTable items={items} onSelect={onSelect}/>);
  const searcher = <KeoBdoSearcher {...searcherData}/>;

  return (
    <>
      <SelectTable
        table={table}
        label="Wyszukiwarka kart KEO"
        onSearchChange={onSearchChange}
        show={show}
        setShow={setShow}
        searcher={searcher}
      />
    </>
  );
}